"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M12 21c.55 0 1-.45 1-1V6.83l.88.88c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L12.7 3.71a.996.996 0 0 0-1.41 0L8.71 6.29c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0l.88-.87V9c0 3.62-2.89 6.22-4.97 7.62-.52.35-.59 1.09-.14 1.53.33.33.87.4 1.26.13C8.74 17.22 10.04 16 11 14.69v5.3c0 .56.45 1.01 1 1.01"
}), 'RampRightRounded');